import {getNotice, pageInfo} from '../api';
const home = {
  namespaced: true,
  state: {
    pageResp: {},
    getNoticeResp: {},
    detailInfoObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.pageResp = data;
    },
    GETNOTICE(state, data) {
      state.getNoticeResp = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },

    //查询事件
    async getNotice({ commit }, obj) {
      let resp = await getNotice(obj);
      commit('GETNOTICE', resp);
    }
  }
}
export default home



// WEBPACK FOOTER //
// ./src/page/home/store/home.store.js